import React from "react";
import { Form } from "../Contacto/Form";

export const ContactoScreen = () => {
  return (
    <div>
      <Form />
    </div>
  );
};
